;(() => {
  const PROGRESS_BAR_MAX = 5
  const PROGRESS_BAR_STAGGER_MS = 150

  function animateCounter(counter, targetValue, duration = 1000) {
    const startTime = performance.now()

    function update(currentTime) {
      const elapsed = currentTime - startTime
      const progress = Math.min(elapsed / duration, 1)
      const currentValue = (progress * targetValue).toFixed(1) // 1 decimal place

      counter.textContent = currentValue

      if (progress < 1) {
        requestAnimationFrame(update)
      } else {
        counter.textContent = targetValue.toFixed(1)
      }
    }

    requestAnimationFrame(update)
  }

  function animate(el) {
    const value = parseFloat(el.dataset.value) || 0

    if (el.classList.contains("spectrum-bar")) {
      el.classList.remove("spectrum-bar--pending")
    } else if (el.classList.contains("counter")) {
      animateCounter(el, value)
    } else {
      el.querySelector(".progress-bar__fill").style.width = (value / PROGRESS_BAR_MAX) * 100 + "%"
    }
  }

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return
        animate(entry.target)
        observer.unobserve(entry.target)
      })
    },
    { threshold: 0.5 }
  )

  document.querySelectorAll(".product-progress-bar-container").forEach(container => {
    container.querySelectorAll(".progress-bar__fill").forEach((fill, index) => {
      fill.style.transitionDelay = index * PROGRESS_BAR_STAGGER_MS + "ms"
    })
    container.querySelectorAll(".progress-bar, .spectrum-bar, .counter").forEach(el => observer.observe(el))
  })
})()
